'use strict';

module.exports = Odigeo.View.extend({
    selectors: {
        steps: '.progress_meta_step',
    },
    init() {
        this.opts = Odigeo.parseOptions(this.widget.options);
        this.setStepStates();
    },
    resetStates() {
        if (Odigeo.AB.isProgressBarMobile) {
            this.$cachedSelectors.steps
                .removeClass('odf-progress-stepper-done odf-progress-stepper-active odf-progress-metas-pending');
        } else {
            this.$cachedSelectors.steps
                .removeClass('odf-progress-metas-done odf-progress-metas-active odf-progress-metas-pending');
        }
    },
    setStepStates() {
        this.resetStates();
        const currentStep = this.opts.step;
        const $steps = this.$cachedSelectors.steps;
        if (Odigeo.AB.isProgressBarMobile) {
            $steps.slice(0, currentStep - 1).addClass('odf-progress-stepper-done');
            $steps.slice(currentStep - 1, currentStep).addClass('odf-progress-stepper-active');
            $steps.slice(currentStep).addClass('odf-progress-stepper-pending');
        } else {
            $steps.slice(0, currentStep - 1).addClass('odf-progress-metas-done');
            $steps.slice(currentStep - 1, currentStep).addClass('odf-progress-metas-active');
            $steps.slice(currentStep).addClass('odf-progress-metas-pending');
        }
    },
    setPaymentState(step) {
        this.opts.step = step;
        this.setStepStates();
    },
});
